import React, { useCallback, useContext, useEffect, useState } from "react";
import ModalContext from '../../../../contexts/ModalContext'
import { ActionsDiv, CloseButton, CloseDiv, CloseImg, Container, Employees, HalfButton, HeaderDiv, HeaderText, InfoProduction, InfoText, ItemsTable, Labor, NameInfo, PlayButton, Select, Separator, StatusProduction, TableInfo, TableInfoText, TableText, TableTitle, TimeProduction, TableItemsContainer, SplitContainer, SplitHeaderDiv, SplitHeaderText, SplitInfoText, SplitInfoProduction, SplitItemsWrapper, SplitItemsTitle, SplitTableHeader, SplitTableBody, SplitTableRow, SplitCheckbox, SplitTableCell, SplitActionsDiv, SplitCancelButton, SplitButtonsGroup, SplitBackButton, SplitAdvanceButton } from "./style";
import cross from '../../../../assets/addStockModal/cross.svg'
import arrowDown from '../../../../assets/addStockModal/excel/arrow-down.svg'
import halfOP from '../../../../assets/fashion/Actions/half-op.svg'
import play from '../../../../assets/fashion/Actions/white-play.svg'
import invoice from '../../../../assets/production-flow/invoice.svg'
import FashionApiService from '../../../../services/FashionApiService';
import eventBus from "../../../../utils/eventBus";
import { FashionProductionOrderData, FashionProductionItemsData } from "../FashionPcp";
import SuccessModal from '../../../../components/SuccessModal';
import GeneratePDFModalFashion from '../GeneratePDFModal';
import FashionBuyOrdersSection from './FashionBuyOrdersSection';
import FashionStageManager, { FashionStageManager as FashionStageManagerNamed } from './FashionStageManager';
const StageManager = FashionStageManager || FashionStageManagerNamed;
import { ChevronDown, ChevronUp } from 'lucide-react';
import { FeedbackContext } from '../../../../contexts/FeedbackContext';
import ConfirmationModal from '../../../../components/ModalConfirmation';
import { useNavigate, useSearchParams } from 'react-router-dom';


const ViewProductionFashion = () => {
    const { setModalActive, setSelectedProductionOrder, selectedProductionOrder } = useContext(ModalContext)
    const { setFeedback } = useContext(FeedbackContext)
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const returnTo = searchParams.get('returnTo');

    const [confirmModal, setConfirmModal] = useState<{
        isOpen: boolean;
        title: string;
        message: string;
        onConfirm: () => void;
    }>({
        isOpen: false,
        title: '',
        message: '',
        onConfirm: () => {},
    });

    const [cuttersList, setCuttersList] = useState<any[]>([]);
    const [dressmakersList, setDressmakersList] = useState<any[]>([]);
    const [isLoadingUsers, setIsLoadingUsers] = useState(true);
    const [errorUsers, setErrorUsers] = useState<string | null>(null);
    const [hasChanges, setHasChanges] = useState(false);
    const [showSplitView, setShowSplitView] = useState(false);
    const [selectedOrderIds, setSelectedOrderIds] = useState<number[]>([]);
    const [isLoadingSplit, setIsLoadingSplit] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [newOpId, setNewOpId] = useState<number | null>(null);
    const [showPDFModal, setShowPDFModal] = useState(false);
    const [isReverting, setIsReverting] = useState(false);
    const [isMaterialsCollapsed, setIsMaterialsCollapsed] = useState(true);
    const [isInsumosCollapsed, setIsInsumosCollapsed] = useState(true);
    const [isEtapasCollapsed, setIsEtapasCollapsed] = useState(true);

    const fetchUsersData = useCallback(async () => {
        try {
            setIsLoadingUsers(true);
            setErrorUsers(null);

            const [cuttersResp, dressmakersResp] = await Promise.all([
                FashionApiService.getUsers('Cortador'),
                FashionApiService.getUsers('Costureira')
            ]);

            const cutters = cuttersResp.data || [];
            const dressmakers = dressmakersResp.data || [];

            setCuttersList([{ id: 0, name: "Selecione..." }, ...cutters]);
            setDressmakersList([{ id: 0, name: "Selecione..." }, ...dressmakers]);

        } catch (err: any) {
            console.error('Erro ao buscar usuários para o modal:', err);
            setErrorUsers('Falha ao carregar lista de usuários.');
        } finally {
            setIsLoadingUsers(false);
        }
    }, []);

    useEffect(() => {
        fetchUsersData();
    }, [fetchUsersData]);

    const handleCloseModal = () => {
        setModalActive(false);
        setSelectedProductionOrder(null);

        if (hasChanges) {
            eventBus.emit('refreshProductionTable');
        } else {
            console.log('Modal fechado sem alterações visíveis.');
        }

        if (returnTo) {
            navigate(returnTo, { replace: true });
        } else if (searchParams.has('opId')) {
            const nextParams = new URLSearchParams(searchParams);
            nextParams.delete('opId');
            navigate({ search: nextParams.toString() }, { replace: true });
        }
    };

    const handleCheckboxChange = (orderId: number) => {
        setSelectedOrderIds(prev => {
            if (prev.includes(orderId)) {
                return prev.filter(id => id !== orderId);
            } else {
                return [...prev, orderId];
            }
        });
    };

    const handleSplit = async () => {
        if (selectedOrderIds.length === 0) {
            setFeedback({ isOpen: true, message: 'Selecione pelo menos um pedido para dividir.', statusOk: false });
            return;
        }

        if (selectedOrderIds.length === selectedProductionOrder.FashionProductionItems.length) {
            setFeedback({ isOpen: true, message: 'Não é possível dividir movendo todos os itens. A OP original ficaria vazia.', statusOk: false });
            return;
        }

        setConfirmModal({
            isOpen: true,
            title: 'Dividir Ordem de Produção',
            message: `Tem certeza que deseja dividir a OP-${selectedProductionOrder.id} movendo os itens selecionados?`,
            onConfirm: async () => {
                setIsLoadingSplit(true);
                try {
                    const response = await FashionApiService.splitProductionOrder(
                        selectedProductionOrder.id,
                        selectedOrderIds
                    );

                    setNewOpId(response.data.id);
                    setShowSuccessModal(true);
                    setHasChanges(true);
                    eventBus.emit('refreshProductionTable');
                } catch (error: any) {
                    console.error('Erro ao dividir ordem de produção:', error);
                    setFeedback({ isOpen: true, message: error.response?.data?.message || 'Erro ao dividir ordem de produção', statusOk: false });
                } finally {
                    setIsLoadingSplit(false);
                }
            }
        });
    };

    const getStatusLabel = (status: number): string => {
        const statusMap: { [key: number]: string } = {
            0: 'Pendente',
            1: 'Iniciado',
            2: 'Concluído',
        };
        return statusMap[status] || String(status);
    };

    const [isStarting, setIsStarting] = useState(false);
    const handleStartProduction = async () => {
        if (!selectedProductionOrder?.id) return;
        const constructed = Boolean(
            selectedProductionOrder.productId &&
                selectedProductionOrder.FashionProductionItems?.length,
        );
        if (!constructed) {
            setFeedback({ isOpen: true, message: 'Monte a OP (produto e itens) no PCP antes de iniciar a produção.', statusOk: false });
            return;
        }
        setConfirmModal({
            isOpen: true,
            title: 'Iniciar Produção',
            message: `Iniciar a produção da OP-${selectedProductionOrder.id}? As ordens de compra serão geradas automaticamente a partir da composição.`,
            onConfirm: async () => {
                setIsStarting(true);
                try {
                    await FashionApiService.startFashionProduction(selectedProductionOrder.id);
                    const res = await FashionApiService.getProductionOrderById(selectedProductionOrder.id);
                    setSelectedProductionOrder(res.data);
                    setHasChanges(true);
                    eventBus.emit('refreshProductionTable');
                    setFeedback({ isOpen: true, message: 'Produção iniciada com sucesso. Ordens de compra provisionadas.', statusOk: true });
                } catch (error: any) {
                    console.error('Erro ao iniciar produção:', error);
                    setFeedback({ isOpen: true, message: error.response?.data?.message || 'Falha ao iniciar a produção.', statusOk: false });
                } finally {
                    setIsStarting(false);
                }
            }
        });
    };

    const handleRevertProduction = async () => {
        if (!selectedProductionOrder?.id) return;
        setConfirmModal({
            isOpen: true,
            title: 'Reverter Início da Produção',
            message: 'Reverter? As ordens de compra ainda pendentes serão removidas e o status voltará para pendente.',
            onConfirm: async () => {
                setIsReverting(true);
                try {
                    await FashionApiService.revertFashionProductionStart(selectedProductionOrder.id);
                    const res = await FashionApiService.getProductionOrderById(selectedProductionOrder.id);
                    setSelectedProductionOrder(res.data);
                    setHasChanges(true);
                    eventBus.emit('refreshProductionTable');
                    setFeedback({ isOpen: true, message: 'Produção revertida com sucesso.', statusOk: true });
                } catch (error: any) {
                    console.error('Erro ao reverter produção:', error);
                    setFeedback({ isOpen: true, message: error.response?.data?.message || 'Falha ao reverter o início da produção.', statusOk: false });
                } finally {
                    setIsReverting(false);
                }
            }
        });
    };

    const handleViewNewOP = () => {
        if (newOpId) {
            setShowSuccessModal(false);
            handleCloseModal();
            console.log(`Visualizar nova OP-${newOpId}`);
        }
    };

    const handleCloseSuccessModal = () => {
        setShowSuccessModal(false);
        handleCloseModal();
    };

    if (!selectedProductionOrder) {
        return (
            <Container>
                <HeaderDiv>
                    <HeaderText>Detalhes da Ordem de Produção</HeaderText>
                    <CloseDiv onClick={() => {
                        setModalActive(false);
                        setSelectedProductionOrder(null);
                    }}>
                        <CloseImg src={cross} alt='Fechar aba' />
                    </CloseDiv>
                </HeaderDiv>
                <InfoProduction>
                    <InfoText>Nenhuma ordem de produção selecionada para visualização/edição.</InfoText>
                </InfoProduction>
            </Container>
        );
    }

    const handleCortadorChangeModal = async (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedUserId = Number(e.target.value);
        const orderId = selectedProductionOrder.id;
        const selectedUserObject = cuttersList.find(c => c.id === selectedUserId);

        setSelectedProductionOrder((prevOrder: any) => {
            if (!prevOrder) return null;
            return {
                ...prevOrder,
                cutterId: selectedUserId === 0 ? null : selectedUserId,
                User_Services_cutterIdToUser: selectedUserId === 0 ? null : selectedUserObject
            };
        });

        try {
            await FashionApiService.updateProductionOrder(orderId, {
                cutterId: selectedUserId === 0 ? null : selectedUserId,
            });
            const newCutterName = selectedUserObject?.name || 'Nenhum';
            setFeedback({ isOpen: true, message: `Cortador da OP-${orderId} atualizado para ${newCutterName}!`, statusOk: true });
            setHasChanges(true)
        } catch (err) {
            console.error(`Erro ao atualizar cortador da OP ${orderId} (via modal):`, err);
            setFeedback({ isOpen: true, message: `Falha ao atualizar cortador da OP-${orderId}.`, statusOk: false });
        }
    };

    const handleCostureiraChangeModal = async (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedUserId = Number(e.target.value);
        const orderId = selectedProductionOrder.id;
        const selectedUserObject = dressmakersList.find(d => d.id === selectedUserId);

        setSelectedProductionOrder((prevOrder: any) => {
            if (!prevOrder) return null;
            return {
                ...prevOrder,
                dressmakerId: selectedUserId === 0 ? null : selectedUserId,
                User_Services_dressmakerIdToUser: selectedUserId === 0 ? null : selectedUserObject
            };
        });

        try {
            await FashionApiService.updateProductionOrder(orderId, {
                dressmakerId: selectedUserId === 0 ? null : selectedUserId,
            });
            const newDressmakerName = selectedUserObject?.name || 'Nenhum';
            setFeedback({ isOpen: true, message: `Costureira da OP-${orderId} atualizada para ${newDressmakerName}!`, statusOk: true });
            setHasChanges(true)
        } catch (err) {
            console.error(`Erro ao atualizar costureira da OP ${orderId} (via modal):`, err);
            setFeedback({ isOpen: true, message: `Falha ao atualizar costureira da OP-${orderId}.`, statusOk: false });
        }
    };

    if (isLoadingUsers) {
        return (
            <Container>
                <HeaderDiv>
                    <HeaderText>Carregando Usuários...</HeaderText>
                    <CloseDiv onClick={() => setModalActive(false)}>
                        <CloseImg src={cross} alt='Fechar aba' />
                    </CloseDiv>
                </HeaderDiv>
                <InfoProduction>
                    <InfoText>Aguarde enquanto carregamos a lista de cortadores e costureiras.</InfoText>
                </InfoProduction>
            </Container>
        );
    }

    if (errorUsers) {
        return (
            <Container>
                <HeaderDiv>
                    <HeaderText>Erro ao Carregar Usuários</HeaderText>
                    <CloseDiv onClick={() => setModalActive(false)}>
                        <CloseImg src={cross} alt='Fechar aba' />
                    </CloseDiv>
                </HeaderDiv>
                <InfoProduction>
                    <InfoText>Ocorreu um erro: {errorUsers}. Por favor, tente novamente.</InfoText>
                </InfoProduction>
            </Container>
        );
    }

    if (showSplitView) {
        return (
            <SplitContainer>
                <SplitHeaderDiv>
                    <SplitHeaderText>Dividir OP-{selectedProductionOrder.id}</SplitHeaderText>
                    <CloseDiv onClick={handleCloseModal}>
                        <CloseImg src={cross} alt='Fechar aba' />
                    </CloseDiv>
                </SplitHeaderDiv>

                <SplitInfoText>
                    Selecione os itens que serão transferidos para a nova Ordem de Produção.
                </SplitInfoText>

                <Separator />

                <InfoProduction>
                    <StatusProduction>
                        <NameInfo>Produto</NameInfo>
                        <InfoText>{selectedProductionOrder.Product?.name || 'teste 8976544132'}</InfoText>
                        <InfoText>{selectedProductionOrder.Product?.name || 'teste 8976544132'}</InfoText>
                    </StatusProduction>
                    <StatusProduction>
                        <NameInfo>Referência</NameInfo>
                        <InfoText>PROD123A</InfoText>
                    </StatusProduction>
                </InfoProduction>

                <InfoProduction>
                    <StatusProduction>
                        <NameInfo>Quantidade de itens</NameInfo>
                        <InfoText>{selectedProductionOrder.totalItems || '30'}</InfoText>
                    </StatusProduction>
                    <StatusProduction>
                        <NameInfo>Cor</NameInfo>
                        <InfoText>{selectedProductionOrder.CollectionColor?.name || 'Verde'}</InfoText>
                        <InfoText>{selectedProductionOrder.CollectionColor?.name || 'Verde'}</InfoText>
                    </StatusProduction>
                </InfoProduction>

                <SplitItemsWrapper>
                    <SplitItemsTitle>Itens</SplitItemsTitle>

                    <SplitTableHeader>
                        <div></div>
                        <div>Pedido</div>
                        <div>Cliente</div>
                        <div>Tamanho</div>
                        <div>Qtd.</div>
                    </SplitTableHeader>

                    <SplitTableBody>
                        {selectedProductionOrder.FashionProductionItems && selectedProductionOrder.FashionProductionItems.map((item: any, index: number) => (
                            <SplitTableRow key={item.fashionOrderId} isEven={index % 2 === 0}>
                                <SplitCheckbox
                                    type="checkbox"
                                    checked={selectedOrderIds.includes(item.fashionOrderId)}
                                    onChange={() => handleCheckboxChange(item.fashionOrderId)}
                                />
                                <SplitTableCell>P-{item.fashionOrderId}</SplitTableCell>
                                <SplitTableCell>
                                    {item.fashionOrder?.company?.companyName || 'N/A'}
                                </SplitTableCell>
                                <SplitTableCell>{item.size || 'M'}</SplitTableCell>
                                <SplitTableCell>{item.quantityForThisProduction}</SplitTableCell>
                            </SplitTableRow>
                        ))}
                    </SplitTableBody>
                </SplitItemsWrapper>

                <SplitActionsDiv>
                    <SplitCancelButton onClick={handleCloseModal}>
                        Cancelar
                    </SplitCancelButton>
                    <SplitButtonsGroup>
                        <SplitBackButton onClick={() => setShowSplitView(false)}>
                            ← Voltar
                        </SplitBackButton>
                        <SplitAdvanceButton
                            onClick={handleSplit}
                            disabled={isLoadingSplit || selectedOrderIds.length === 0}
                        >
                            {isLoadingSplit ? 'Processando...' : 'Avançar'}
                        </SplitAdvanceButton>
                    </SplitButtonsGroup>
                </SplitActionsDiv>
            </SplitContainer>
        );
    }


    return (
        <>
            <Container>
                <HeaderDiv>
                    <HeaderText>
                        Ordem de Produção OP-{selectedProductionOrder.id}
                    </HeaderText>
                    <CloseDiv onClick={handleCloseModal}>
                        <CloseImg src={cross} alt='Fechar aba' />
                    </CloseDiv>
                </HeaderDiv>
                <InfoProduction>
                    <StatusProduction>
                        <NameInfo>Status</NameInfo>
                        <InfoText>{getStatusLabel(selectedProductionOrder.status)}</InfoText>
                    </StatusProduction>
                    <TimeProduction>
                        <NameInfo>Tempo estimado</NameInfo>
                        <InfoText>1h23m45s</InfoText>
                    </TimeProduction>
                </InfoProduction>
                <Separator />
                <InfoProduction>
                    <StatusProduction>
                        <NameInfo>Produto</NameInfo>
                        <InfoText>{selectedProductionOrder.Product?.name || 'N/A'}</InfoText>
                    </StatusProduction>
                    <StatusProduction>
                        <NameInfo>Referência</NameInfo>
                        <InfoText>PROD123A</InfoText>
                    </StatusProduction>
                </InfoProduction>
                <InfoProduction>
                    <StatusProduction>
                        <NameInfo>Quantidade de itens</NameInfo>
                        <InfoText>{selectedProductionOrder.totalItems || 0}</InfoText>
                    </StatusProduction>
                    <StatusProduction>
                        <NameInfo>Cor</NameInfo>
                        <InfoText>{selectedProductionOrder.CollectionColor?.name || 'N/A'}</InfoText>
                    </StatusProduction>
                </InfoProduction>
                <Labor>
                    <Employees>
                        <InfoText>Cortador</InfoText>
                        <Select
                            value={selectedProductionOrder.cutterId || 0}
                            onChange={handleCortadorChangeModal}
                            className="p-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        >
                            {cuttersList.map((cutter) => (
                                <option key={cutter.id} value={cutter.id}>
                                    {cutter.name}
                                </option>
                            ))}
                        </Select>
                    </Employees>
                    <Employees>
                        <InfoText>Costureira</InfoText>
                        <Select
                            value={selectedProductionOrder.dressmakerId || 0}
                            onChange={handleCostureiraChangeModal}
                            className="p-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        >
                            {dressmakersList.map((dressmaker) => (
                                <option key={dressmaker.id} value={dressmaker.id}>
                                    {dressmaker.name}
                                </option>
                            ))}
                        </Select>
                    </Employees>
                </Labor>
                <ItemsTable>
                    <InfoText>Itens</InfoText>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr 1fr',
                        padding: '10px 12px',
                        fontSize: '12px',
                        color: '#696969',
                        fontWeight: '400',
                        backgroundColor: '#F5F5F5',
                        borderRadius: '4px 4px 0 0'
                    }}>
                        <div>Pedidos</div>
                        <div>Cliente</div>
                        <div>Qtd.</div>
                    </div>
                    <TableItemsContainer>
                        {selectedProductionOrder.FashionProductionItems && selectedProductionOrder.FashionProductionItems.length > 0 ? (
                            selectedProductionOrder.FashionProductionItems.map((item: FashionProductionItemsData | any, index: number) => (
                                <div
                                    key={item.id}
                                    style={{
                                        display: 'grid',
                                        gridTemplateColumns: '1fr 1fr 1fr',
                                        padding: '12px',
                                        alignItems: 'center',
                                        backgroundColor: index % 2 === 0 ? '#FFFFFF' : '#F5F5F5',
                                        borderBottom: '1px solid #E0E0E0'
                                    }}
                                >
                                    <div style={{ fontSize: '13px', color: '#303030' }}>PED-{item.fashionOrderId}</div>
                                    <div style={{ fontSize: '13px', color: '#303030' }}>{item.fashionOrder?.company?.companyName || 'N/A'}</div>
                                    <div style={{ fontSize: '13px', color: '#303030' }}>{item.quantityForThisProduction}</div>
                                </div>
                            ))
                        ) : (
                            <InfoText>Nenhum item associado a esta ordem de produção.</InfoText>
                        )}
                    </TableItemsContainer>
                </ItemsTable>

                {/* Section 1: Materiais (Collapsed by default) */}
                <div style={{ marginTop: '20px', width: '100%' }}>
                    <div
                        onClick={() => setIsMaterialsCollapsed(!isMaterialsCollapsed)}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '12px 16px',
                            backgroundColor: '#f8fafc',
                            border: '1px solid #e2e8f0',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            marginBottom: isMaterialsCollapsed ? '0px' : '12px',
                            userSelect: 'none',
                        }}
                    >
                        <span style={{ fontSize: '15px', fontWeight: 600, color: '#303030' }}>
                            Materiais
                        </span>
                        <button
                            type="button"
                            style={{
                                width: '28px',
                                height: '28px',
                                borderRadius: '50%',
                                border: '1px solid #cbd5e1',
                                backgroundColor: '#ffffff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                color: '#64748b',
                            }}
                        >
                            {isMaterialsCollapsed ? <ChevronDown size={16} /> : <ChevronUp size={16} />}
                        </button>
                    </div>
                    {!isMaterialsCollapsed && (
                        <FashionBuyOrdersSection
                            servicesId={selectedProductionOrder.id}
                            type="materials"
                        />
                    )}
                </div>

                {/* Section 2: Insumos (Collapsed by default) */}
                <div style={{ marginTop: '12px', width: '100%' }}>
                    <div
                        onClick={() => setIsInsumosCollapsed(!isInsumosCollapsed)}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '12px 16px',
                            backgroundColor: '#f8fafc',
                            border: '1px solid #e2e8f0',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            marginBottom: isInsumosCollapsed ? '0px' : '12px',
                            userSelect: 'none',
                        }}
                    >
                        <span style={{ fontSize: '15px', fontWeight: 600, color: '#303030' }}>
                            Insumos
                        </span>
                        <button
                            type="button"
                            style={{
                                width: '28px',
                                height: '28px',
                                borderRadius: '50%',
                                border: '1px solid #cbd5e1',
                                backgroundColor: '#ffffff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                color: '#64748b',
                            }}
                        >
                            {isInsumosCollapsed ? <ChevronDown size={16} /> : <ChevronUp size={16} />}
                        </button>
                    </div>
                    {!isInsumosCollapsed && (
                        <FashionBuyOrdersSection
                            servicesId={selectedProductionOrder.id}
                            type="resources"
                        />
                    )}
                </div>

                {/* Section 3: Etapas de Produção (Collapsed by default, POR ÚLTIMO) */}
                <div style={{ marginTop: '12px', width: '100%', marginBottom: '16px' }}>
                    <div
                        onClick={() => setIsEtapasCollapsed(!isEtapasCollapsed)}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '12px 16px',
                            backgroundColor: '#f8fafc',
                            border: '1px solid #e2e8f0',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            marginBottom: isEtapasCollapsed ? '0px' : '12px',
                            userSelect: 'none',
                        }}
                    >
                        <span style={{ fontSize: '15px', fontWeight: 600, color: '#303030' }}>
                            Etapas de Produção
                        </span>
                        <button
                            type="button"
                            style={{
                                width: '28px',
                                height: '28px',
                                borderRadius: '50%',
                                border: '1px solid #cbd5e1',
                                backgroundColor: '#ffffff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                color: '#64748b',
                            }}
                        >
                            {isEtapasCollapsed ? <ChevronDown size={16} /> : <ChevronUp size={16} />}
                        </button>
                    </div>
                    {!isEtapasCollapsed && (
                        <StageManager opId={selectedProductionOrder.id} isFashion={true} />
                    )}
                </div>
                <ActionsDiv style={{ flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                    {selectedProductionOrder.status === 0 && (
                        <div>
                            <HalfButton onClick={() => setShowSplitView(true)}>
                                <img src={halfOP} alt="Dividir OP" />Dividir OP
                            </HalfButton>
                        </div>
                    )}
                    <div>
                        <HalfButton onClick={() => setShowPDFModal(true)}>
                            <img src={invoice} alt="PDF" />Gerar PDF
                        </HalfButton>
                    </div>
                    {selectedProductionOrder.status === 1 && (
                        <div>
                            <HalfButton
                                type="button"
                                onClick={handleRevertProduction}
                                disabled={isReverting}
                                style={{ borderColor: '#c53030', color: '#c53030' }}
                            >
                                {isReverting ? 'Revertendo…' : 'Reverter'}
                            </HalfButton>
                        </div>
                    )}
                    {selectedProductionOrder.status === 0 && (
                        <div>
                            <PlayButton
                                type="button"
                                onClick={handleStartProduction}
                                disabled={
                                    isStarting ||
                                    !(
                                        selectedProductionOrder.productId &&
                                        selectedProductionOrder.FashionProductionItems?.length
                                    )
                                }
                                style={
                                    isStarting ||
                                    !(
                                        selectedProductionOrder.productId &&
                                        selectedProductionOrder.FashionProductionItems?.length
                                    )
                                        ? { opacity: 0.55, cursor: 'not-allowed' }
                                        : undefined
                                }
                                title={
                                    !(
                                        selectedProductionOrder.productId &&
                                        selectedProductionOrder.FashionProductionItems?.length
                                    )
                                        ? 'Monte a OP no PCP antes de iniciar.'
                                        : undefined
                                }
                            >
                                <img src={play} alt="Iniciar produção" />
                                {isStarting ? 'Iniciando…' : 'Iniciar produção'}
                            </PlayButton>
                        </div>
                    )}
                </ActionsDiv>
            </Container>
            {showSuccessModal && (
                <SuccessModal
                    isOpen={showSuccessModal}
                    title="Nova OP criada com sucesso"
                    description={`A OP-${selectedProductionOrder.id} foi dividida e a nova OP-${newOpId} foi criada com os itens selecionados.`}
                    primaryButtonText="Ok, entendi"
                    secondaryButtonText="Visualizar nova OP"
                    onPrimaryClick={handleCloseSuccessModal}
                    onSecondaryClick={handleViewNewOP}
                />
            )}
            {showPDFModal && (
                <GeneratePDFModalFashion
                    onClickClose={() => setShowPDFModal(false)}
                    productionOrder={selectedProductionOrder}
                />
            )}
            <ConfirmationModal
                isOpen={confirmModal.isOpen}
                title={confirmModal.title}
                message={confirmModal.message}
                actions={[
                    {
                        label: 'Cancelar',
                        onClick: () => setConfirmModal(prev => ({ ...prev, isOpen: false })),
                        variant: 'outline',
                    },
                    {
                        label: 'Confirmar',
                        onClick: () => {
                            confirmModal.onConfirm();
                            setConfirmModal(prev => ({ ...prev, isOpen: false }));
                        },
                        variant: 'primary',
                    },
                ]}
            />
        </>
    )
}

export default ViewProductionFashion;
